import { ContractEs } from "@edp-models/ES/es-contract.model";

export interface IContractEsState {
    contractsEs: ContractEs[];
    selectedContractEs: {
        data: ContractEs;
        lastAPIError: Error;
    };
    isSingleContractEs: boolean;
    // pendingContracts: PendingContract[];
}

export const initialContractKeepState = {
    contractsEs: [],
    selectedContractEs: {
        data: null,
        lastAPIError: null,
    },
    isSingleContractEs: true,
};

export const initialContractEsState: IContractEsState = {
    ...initialContractKeepState,
};
